import GenericService from "./GenericService";

export default class ObraService extends GenericService{
    constructor(){
        super('/api/obras')
    }
}